/** @jsx jsx */
import { jsx, Text } from "theme-ui"
import * as styles from "./styles"
import moment from "moment"
import React from "react"

interface CreatedOnProps {
  createdOn?: string
}

export const CreatedOn: React.FC<CreatedOnProps> = ({ createdOn }) => {
  const formattedCreatedOn = moment(createdOn).format("ddd, MMM d YYYY")

  return (
    <Text variant="small" sx={styles.root}>
      {formattedCreatedOn}
    </Text>
  )
}
